// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

export const SET_REFRESHING_STATE = 'SET_REFRESHING_STATE';
export const SET_REFRESHING_CALL = 'SET_REFRESHING_CALL';

// lang.js
export const SET_LOCALE = 'SET_LOCALE'



// WEBPACK FOOTER //
// ./resources/js/store/mutation-types.js